import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Breadcrumb, Title } from "../../../css/commun";
import { URL_Dev } from "../Variables";
import { fetchWpCached, getPortfolioLanguage, getWpCachedSeed } from "../../../api/wpClient";
import { ListPortfolio } from "./ListPortfolio";
import Pages from "../../../Model/Pages";
import SeoHead from "../../Seo/SeoHead";
import { withTranslation } from "react-i18next";
import ReactGA from "react-ga";
import cookies from "js-cookie";
import { TailSpin } from 'react-loader-spinner';
import { Table } from "./Portfolio";

const Portfolios = (props) => {  
  const title = props.location.pathname;
  const splitState = title.split('/');
  const { t } = props;
  const currentLanguage = cookies.get('i18next') || 'fr';

  const resolveFilterLabel = () => {
    let nextFilterLabel = splitState[1].length === 2 ? splitState[3] : splitState[2];
    if (nextFilterLabel === undefined) {
      nextFilterLabel = localStorage.getItem('filterLabel') || '';
    }
    return nextFilterLabel;
  };

  const applyFilter = (result, lng, activeFilterLabel) => {
    return result.filter((item) => {
      const isLangMatch = getPortfolioLanguage(item) === lng;

      const isContentMatch =
        activeFilterLabel &&
        Array.isArray(item.techo_choice_content) &&
        item.techo_choice_content.some((tech) =>
          tech.name.toUpperCase().includes(activeFilterLabel.toUpperCase())
        );

      const isDesignMatch =
        activeFilterLabel &&
        activeFilterLabel.toUpperCase().includes("DESIGN") &&
        Array.isArray(item.categoriesportfolio) &&
        item.categoriesportfolio.includes(7);

      const isEcommerceMatch =
        activeFilterLabel &&
        activeFilterLabel.toUpperCase().includes("E-COMMERCE") &&
        Array.isArray(item.categoriesportfolio) &&
        item.categoriesportfolio.includes(254);

      return isLangMatch && (isContentMatch || isDesignMatch || isEcommerceMatch);
    });
  };

  const seedItems = getWpCachedSeed("portfolioList") || [];
  const initialFilterLabel = resolveFilterLabel();
  const initialFilteredItems = applyFilter(seedItems, currentLanguage, initialFilterLabel);

  const [items, setItems] = useState(seedItems);
  const [itemsFiltred, setItemsFiltred] = useState(initialFilteredItems);
  const [filterLabel, setFilterLabel] = useState(initialFilterLabel);
  const [number, setNumber] = useState(12);
  const [pages, setPages] = useState([]);
  const [langue, setLangue] = useState("fr");
  const [loading, setLoading] = useState(initialFilteredItems.length === 0);

  useEffect(() => {
    setLangue(currentLanguage);
    document.body.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';
  }, [currentLanguage]);

  const scrollToEnd = () => {
    setNumber(number + 3);
  };

  window.onscroll = function () {
    if (window.innerHeight + document.documentElement.scrollTop > (document.documentElement.offsetHeight - 300)) {
      scrollToEnd();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname);

    const activeFilterLabel = resolveFilterLabel();
    setFilterLabel(activeFilterLabel);
    setLangue(currentLanguage);

    const applyPortfolio = (result) => {
      setItems(result);
      setItemsFiltred(applyFilter(result, currentLanguage, activeFilterLabel));
      setLoading(false);
    };

    applyPortfolio(seedItems);
    fetchWpCached("portfolioList", { onRevalidated: applyPortfolio })
      .then(applyPortfolio)
      .catch((error) => {
        console.error("Erreur lors de la rÃ©cupÃ©ration des donnÃ©es :", error);
        setLoading(false);
      });

    fetchWpCached("pages", { onRevalidated: setPages }).then(setPages).catch(() => {});
  }, [currentLanguage, props.location.pathname]);

  const portfolio = itemsFiltred.map((element) => ({
    id: element.id,
    title: element.title?.rendered || '',
    slug: element.slug,
    image:
      element._embedded?.['wp:featuredmedia']?.[0]?.source_url ||
      element.featured_image_url ||
      element.x_featured_media_large ||
      '',
    isLightweight: Boolean(element.is_lightweight),
  }));

  const page = [];
  pages.map(element =>
    decodeURI(element.slug) === (splitState[1].length === 2 ? splitState[2] : splitState[1]) &&
    page.push(new Pages(element.id, element.title.rendered, element.content.rendered, element.parent, element.slug, element.yoast_head_json.og_description, element.date, element.excerpt.rendered)));

  const titre = page[0] !== undefined ? page[0].title.replace("&#8217;", "'") : "...Loading";

  function formatLabel(label) {
    if (label === 'design-ux-ui') {
      return 'Design UX/UI';
    }
    if (label === 'e-commerce') {
      return 'E-commerce';
    }
    return label
      .replace(/-/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  return (
    <>
      <SeoHead
        title={titre}
        description={page[0]?.description}
        pathname={props.location.pathname}
        image={`${URL_Dev}/images/oxton.png`}
      />
      <div className="container" >
        <Breadcrumb>
          <p>
            <Link className="retour" to="/">{t('Home_link')}</Link> / <span>{formatLabel(filterLabel)}</span>
          </p>
        </Breadcrumb>
        <Title>
          <h1>{formatLabel(filterLabel)}</h1>
        </Title>

        <Table>
          {loading
            ? <div className="loading">
              <TailSpin color="#17406F" />
            </div>
            : <>
              <ListPortfolio portfolio={portfolio} number={number} langue={langue} />
              {(number < itemsFiltred.length) ? <img className="arrow" src="/images/portfolio/Group 20195.svg" alt="arrow" onClick={() => setNumber(number + 9)} />
                : number < portfolio.length && <img className="arrow" src="/images/portfolio/Group 20195.svg" alt="arrow" onClick={() => setNumber(number + 3)} />
              }
            </>
          }
        </Table>
      </div >
    </>
  );
};

export default withTranslation()(Portfolios);
